import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import EnhancedProductDetail from '../../components/EnhancedProductDetail/EnhancedProductDetail';

function ProductDetail({ onAddToCart, lang = 'en' }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productDoc = await getDoc(doc(db, 'products', id));
        if (productDoc.exists()) {
          setProduct({ id: productDoc.id, ...productDoc.data() });
        } else {
          setError('Product not found');
        }
      } catch (err) {
        setError('Error loading product: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>Loading product...</div>;
  }
  if (error) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: 'red' }}>
        <p>{error}</p>
        <button onClick={() => navigate('/shop')}>Back to Shop</button>
      </div>
    );
  }
  if (!product) return null;

  return (
    <EnhancedProductDetail
      product={product}
      onAddToCart={onAddToCart}
      onBack={() => navigate('/shop')}
      lang={lang}
    />
  );
}

export default ProductDetail;